import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import CSSModules from 'react-css-modules';
import isPlainObject from 'lodash/isPlainObject';

import Icon from '../../../Icon';
import Popup from '../../Popup';

import { COLORS } from '../../../../constants/styles';
import { SUCCESS } from '../../../../constants/strings';
import { PROPS_LIST } from '../../../../constants/props';
import Button from '../../../Button';

import styles from '../index.styl';

const AlertBox = ({
  iconType,
  onClose,
  text,
  type,
  title,
  values,
  showBtn,
  infoErrorIcon,
  ...props
}) => {
  const valuesData = values || {};
  const message = isPlainObject(text) ? (
    <FormattedMessage {...text} values={valuesData} />
  ) : (
    text
  );
  const iconName = iconType || 'exclamation-mark-hover';
  const fillColor = type === 'success' ? COLORS.greenLime : COLORS.orangePink;

  return (
    <Popup
      onClose={onClose}
      mobileFullScreen={false}
      opened={!!text}
      white
      width="rubber"
      withHeading={false}
      {...props}
    >
      <div styleName="root">
        <div styleName="content">
          <Icon
            name={type === 'error' ? infoErrorIcon || type : iconName}
            size={40}
            className="pb2"
            style={{ fill: fillColor }}
          />
          {title && (
            <p className={styles.title}>
              <FormattedMessage id={title} />
            </p>
          )}
          <p className="pt3 tc" styleName="message">
            {message}
          </p>
          {showBtn && (
            <Button color="primary" onClick={onClose} styleName="btn">
              <FormattedMessage id="auth.errors.gotIt" />
            </Button>
          )}
        </div>
      </div>
    </Popup>
  );
};

AlertBox.propTypes = {
  onClose: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ]),
  type: PropTypes.oneOf(PROPS_LIST.appAlert.type),
  iconType: PropTypes.string,
  values: PropTypes.object,
  showBtn: PropTypes.bool,
  title: PropTypes.string,
  infoErrorIcon: PropTypes.string,
};

AlertBox.defaultProps = {
  text: SUCCESS,
  type: 'success',
  onClose: null,
  iconType: null,
  showBtn: false,
  title: null,
};

export default CSSModules(AlertBox, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/AppAlert/AlertBox/index.jsx